const CONSENT_KEY = "quantarock_cookie_consent";
const GA_ID = "G-VZD2WS8NYV";
const CLARITY_ID = "vyr566f65m";

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // localStorage unavailable (private browsing, etc.) — the choice just
    // won't persist, so the banner will reappear next visit.
  }
};

export const openConsentPreferences = () => {
  window.dispatchEvent(new Event("opencookiepreferences"));
};

let analyticsLoaded = false;

// Loads Google Analytics (GA4) and Microsoft Clarity. Only called once
// consent is given — either right after the visitor accepts, or on a
// later visit once their prior "accepted" choice is read back.
export const loadAnalyticsScripts = () => {
  if (analyticsLoaded) return;
  analyticsLoaded = true;

  const gaScript = document.createElement("script");
  gaScript.async = true;
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_ID);
};
